import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Divider, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import { fetchLoggedInUserInfoAsync, setAbovePropertyUser, setViewAsForAbovePropUser } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import CollapsibleContainer from "components/common/CollapsibleContainer";
import { resetAllModifiedFilters } from "components/common/Filters/GlobalFilters.slice";
import Menu from "components/common/Menu";
import Typography from "components/common/Typography";
import AvatarItem from "components/common/UserAvatarList/item";
import InncodeDropDown from "components/common/dropdowns/InncodeDropDown";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { userLogout } from "utils/AuthUtils";
import { abovePropUserView } from "utils/CommonConstants";
import { getUserHltId } from "utils/CommonFunctions";
import { getUserName } from "utils/StoreUtils";
import Notifications from "../Notifications";
import { setOpenEmailDialog } from "../dashboard/Dashboard.slice";
import { setUseEffectState } from "../dashboard/PropertyOverview/PropertyOverview.slice";

interface Props {
  toggleDrawer?: any;
}

function UserMenu(props: Props) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { toggleDrawer } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const [openCollapseContainer, setOpenCollapseContainer] = useState(false);
  const [openViewCollapseContainer, setOpenViewCollapseContainer] = useState(false);
  const viewAs = useAppSelector((state) => state.app.viewAsForAbovePropUser);
  const { isImpersonated } = useAppSelector((state: any) => state.app.impersonationDetails);
  const { isCorp, isAbovePropertyUser } = useAppSelector((state) => state.app.loggedInUserDetails);

  const getMenuOptions = () =>
    [
      {
        label: "Account Settings",
        isDisabled: false,
        onClick: (e: any) => {
          toggleDrawer(false)(e);
          dispatch(setOpenEmailDialog(true));
        }
      },
      {
        label: "Logout",
        isDisabled: false,
        onClick: userLogout,
        hide: isImpersonated
      }
    ].filter((item) => !item.hide);

  const handleClick = () => {
    setOpenCollapseContainer((state) => !state);
  };

  const handleViewClick = () => {
    setOpenViewCollapseContainer((state) => !state);
  };

  const getUsernameAvatar = () => {
    return getUserName() ? <AvatarItem variant="neutral" size="small" user={getUserName(true)} /> : <></>;
  };

  const viewOnChange = (value: string) => {
    dispatch(setViewAsForAbovePropUser(value));
    dispatch(setAbovePropertyUser(value === abovePropUserView["AP"]));
    dispatch(resetAllModifiedFilters());
    dispatch(fetchLoggedInUserInfoAsync({ size: 1, hltIds: getUserHltId(), isImpersonated }));
    dispatch(setUseEffectState(true));
    navigate("/", {
      state: { viewChange: true },
      replace: true
    });
    toggleDrawer(false)(value);
  };

  return (
    <>
      {isMobileScreen ? (
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"}>
          <Divider sx={{ width: "60%", marginTop: "16px" }} />
          <Grid container flexDirection={"column"} alignItems={"center"}>
            {(isAbovePropertyUser || viewAs === abovePropUserView["HU"]) && (
              <>
                <Grid item>
                  <Button onClick={handleViewClick} sx={{ gap: "12px", color: tokens.Text.General.Secondary }}>
                    <Typography showBold variant={"h5"}>
                      {viewAs}
                    </Typography>
                    <KeyboardArrowDownIcon />
                  </Button>
                </Grid>
                <Grid item>
                  <CollapsibleContainer isOpen={openViewCollapseContainer}>
                    {Object.entries(abovePropUserView).map(([key, label]) => (
                      <MenuItem
                        sx={{
                          backgroundColor: viewAs === label ? tokens.Background.General.Color : "none",
                          color: viewAs === label ? tokens.Text.General.Color : "none"
                        }}
                        value={label}
                        key={key}
                        onClick={() => viewOnChange(label)}
                      >
                        <Typography variant={"h5"}>{label}</Typography>
                      </MenuItem>
                    ))}
                  </CollapsibleContainer>
                </Grid>
              </>
            )}
            <Grid item>
              <Button onClick={handleClick} sx={{ gap: "12px", color: tokens.Text.General.Secondary }}>
                {getUsernameAvatar()}
                <Typography showBold variant={"h5"}>
                  {getUserName()}
                </Typography>
                <KeyboardArrowDownIcon />
              </Button>
            </Grid>
            <Grid item>
              <CollapsibleContainer isOpen={openCollapseContainer}>
                {getMenuOptions().map((item: any) => (
                  <MenuItem key={item.label} disabled={item.isDisabled} onClick={item.onClick}>
                    <Typography variant={"h5"} color={tokens.Text.General.Secondary}>
                      {item.label}
                    </Typography>
                  </MenuItem>
                ))}
              </CollapsibleContainer>
            </Grid>
          </Grid>
        </Box>
      ) : (
        <>
          <Box
            sx={{
              marginLeft: "auto",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "center"
            }}
          >
            {(isAbovePropertyUser || viewAs === abovePropUserView["HU"]) && (
              <Box display={"flex"} flexDirection={"row"} alignItems={"center"} gap={"8px"} marginRight={"24px"}>
                <Typography
                  variant={"body2"}
                  color={tokens.Text.General.PrimaryBody}
                  children={"Change View"}
                ></Typography>
                <InncodeDropDown
                  parentBoxWidth="auto"
                  backgroundColor={tokens.Background.General.Secondary}
                  width={isMobileScreen ? "170px" : "auto"}
                  height="24px"
                  color={tokens.Text.General.Secondary}
                  value={viewAs}
                  borderColor={`${tokens.Border.General.Tertiary} 2px solid`}
                  borderRadius="8px"
                  view={"aboveUserView"}
                  isCorp={isCorp}
                  onChange={viewOnChange}
                />
              </Box>
            )}

            <Menu startIcon={getUsernameAvatar()} label={getUserName()} options={getMenuOptions()}></Menu>
          </Box>
          <Notifications />
        </>
      )}
    </>
  );
}

export default UserMenu;
